export default function getApiData(databit) {
    const data = {
        mainURL: process.env.VUE_APP_MAIN_URL,
        version: 'v2'
    }
    return data[databit]
}

